import React, { useEffect } from "react";
import { Form, InputNumber, Button, Select, Input } from "antd";
import { createSubscription } from "../../features/subscription/subscriptionSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
const { Option } = Select;

const CreateSubscription = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, creating, message, isCreateSuccess } = useSelector(
    (state) => state.subscription
  );

  const onFinish = (data) => {
    console.log(data);
    dispatch(createSubscription(data));
  };

  useEffect(() => {
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isCreateSuccess) {
      messageApi.open({
        type: "success",
        content: "Subscription created successfully",
      });
    }

    if (isCreateSuccess) {
      navigate("/admin/subscription");
    }
  }, [isError, message, isCreateSuccess, messageApi, navigate]);

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Subscription & Bundle</h3>
      <Form
        layout="vertical"
        onFinish={onFinish}
        initialValues={{ period: "month", status: "1", currency: "aud" }}
      >
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input the name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Currency"
          name="currency"
          rules={[{ required: true, message: "Please select the currency!" }]}
        >
          <Select>
            <Option value="aud">AUD</Option>
            <Option value="usd">USD</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Price"
          name="amount"
          rules={[{ required: true, message: "Please input the price!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Period"
          name="period"
          rules={[{ required: true, message: "Please select the period!" }]}
        >
          <Select>
            <Option value="week">Weekly</Option>
            <Option value="month">Monthly</Option>
            <Option value="year">Yearly</Option>
            <Option value="one-off">One Off</Option>
          </Select>
        </Form.Item>

        <Form.Item
          label="Hole In One Credits"
          name="hole_in_one_credits"
          rules={[{ required: true, message: "Please input hole in one credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Hole Out Credits"
          name="hole_out_credits"
          rules={[{ required: true, message: "Please input hole out credits!" }]}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: "Please add a description!" }]}
        >
          <Input.TextArea rows={4} />
        </Form.Item>

        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="0">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={creating}>
            {creating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateSubscription;
